import { Sprout } from "lucide-react";
import { MaskedLines, Reveal, Eyebrow } from "../components/motion";
import { useCart } from "../context/CartContext";
import { useProducts } from "../hooks/useProducts";
import { formatPrice } from "../config/site";

export default function KitPage() {
  const { products } = useProducts();
  const { add } = useCart();
  const kits = products.filter((p) => p.category === "kit");

  return (
    <main data-testid="kit-page" className="pb-20">
      <section className="bg-gradient-to-b from-lilac-soft/70 to-transparent py-14 sm:py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <Reveal>
            <Eyebrow className="justify-center">Routine & Kit</Eyebrow>
          </Reveal>
          <MaskedLines
            as="h1"
            delay={0.1}
            lines={["Non prodotti raggruppati,", "ma veri percorsi di cura"]}
            className="mt-4 font-serif text-4xl sm:text-5xl text-plum tracking-tight leading-[1.12]"
          />
          <Reveal delay={0.4}>
            <p className="mt-6 text-base sm:text-lg text-plum/60 leading-relaxed max-w-2xl mx-auto">
              La costanza fa la differenza. Ogni percorso ti accompagna per settimane con il
              Trattamento Rapida Crescita, passo dopo passo.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 mt-14 space-y-6">
        {kits.map((kit, i) => (
          <Reveal key={kit.slug} delay={i * 0.08}>
            <div
              data-testid={`kit-row-${kit.slug}`}
              className={`grid md:grid-cols-2 gap-8 items-center bg-mist rounded-[2.5rem] p-6 sm:p-10 border border-transparent hover:border-lilac-light transition-colors duration-500 ${
                i % 2 === 1 ? "md:[direction:rtl]" : ""
              }`}
            >
              <div className="[direction:ltr] rounded-[2rem] overflow-hidden bg-white border-4 border-white shadow-lg">
                <img src={kit.image} alt={kit.name} className="w-full aspect-[4/3.4] object-cover" loading="lazy" />
              </div>
              <div className="[direction:ltr]">
                {kit.badge && (
                  <span className="inline-block bg-lilac text-white text-[10px] font-bold uppercase tracking-[0.14em] px-4 py-1.5 rounded-full">
                    {kit.badge}
                  </span>
                )}
                <p className="mt-3 uppercase text-xs font-bold tracking-[0.22em] text-matcha">
                  Percorso {kit.months} {kit.months === 1 ? "mese" : "mesi"}
                </p>
                <h2 className="mt-2 font-serif text-2xl sm:text-3xl text-plum tracking-tight">{kit.name}</h2>
                <p className="mt-4 text-sm sm:text-base text-plum/60 leading-relaxed">{kit.short}</p>
                <ul className="mt-4 space-y-2">
                  {(kit.includes || []).map((inc) => (
                    <li key={inc} className="text-sm text-plum/70 flex items-center gap-2">
                      <Sprout className="w-4 h-4 text-lilac-dark shrink-0" /> {inc}
                    </li>
                  ))}
                </ul>
                <div className="mt-6 flex items-center gap-4 flex-wrap">
                  <span className="font-serif text-3xl text-plum">{formatPrice(kit.price)}</span>
                  <button
                    data-testid={`kit-add-${kit.slug}`}
                    onClick={() => add(kit)}
                    className="px-7 py-3.5 rounded-full bg-lilac text-white font-bold text-xs uppercase tracking-[0.14em] hover:bg-lilac-dark active:scale-95 transition-all duration-300"
                  >
                    Inizia il percorso
                  </button>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </section>
    </main>
  );
}
